module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin_ro.adf40df0.jpg";